<app-nav-menu></app-nav-menu>

<div class="container">
  <h3 class="text-dark text-center my-5">Cancel Policy</h3>
  <div class="row">
    <div class=" col-lg-6 col-md-6 col-sm-6">
      <label  class="labelofmodifyserachinputs">Itinerary No.</label>
      <input type="text" class="inputStyle" name="cnic" [(ngModel)]="cancelPolicy.itinerary">
      <span class="highlight"></span>
      <span class="bar"></span>
    </div>
  
    <div class=" col-lg-6 col-md-6 col-sm-6">
      <label  class="labelofmodifyserachinputs">Policy No.</label>
      <input type="text" class="inputStyle" name="policyNo" [(ngModel)]="cancelPolicy.policyno">
      <span class="highlight"></span>
      <span class="bar"></span>
    </div>
  </div>
  <div class="row mt-3">
    <div class=" col-lg-6 col-md-6 col-sm-6">
      <label  class="labelofmodifyserachinputs">PNR</label>
      <input type="text" class="inputStyle" name="pnr" [(ngModel)]="cancelPolicy.pnr">
      <span class="highlight"></span>
      <span class="bar"></span>
    </div>
  
    <div class=" col-lg-6 col-md-6 col-sm-6">
      <label  class="labelofmodifyserachinputs">Purchase Date</label>
      <input type="date" class="inputStyle" name="purchasedate" [(ngModel)]="cancelPolicy.purchaseDate">
      <span class="highlight"></span>
      <span class="bar"></span>
    </div>
  </div>
  <div class="row mt-3">
    <span class="dd-button button-87" (click)="CancelBookedPlans()" >Cancel Policy</span>
  </div>

  <ng-template #sweet let-modal>
    <div class="modal-success">
      <img class="sucesspopup" src="assets/img/newsuccess.gif" />
      <h2 class="textpopupsuccess">Cancellation Details</h2>
      <div class="container-fluid">
        <div class="my-2 pl-2">
          <div class="row col-12"><span class="col-6 text-dark">State:</span><span class="col-6 text-dark"> <b>{{cancelPolicyResponse.PolicyResponse.ItineraryState}}</b></span></div>
          <div class="row col-12"><span class="col-6 text-dark">Itinerary ID:</span><span class="col-6 text-dark"><b>{{cancelPolicyResponse.PolicyResponse.ItineraryID}}</b></span></div>
          <div class="row col-12"><span class="col-6 text-dark">Policy No:</span> <span class="col-6 text-dark"><b>{{cancelPolicyResponse.PolicyResponse.PolicyNo}}</b></span></div>
          <div class="row col-12"><span class="col-6 text-dark">PNR:</span> <span class="col-6 text-dark"><b>{{cancelPolicyResponse.PolicyResponse.PNR}}</b></span></div>
          <div class="row col-12"><span class="col-6 text-dark">Cancellation Date:</span> <span class="col-6 text-dark"><b>{{cancelPolicyResponse.PolicyResponse.PolicyCancelDateTime}}</b></span></div>
          <div class="row col-12"><span class="col-6 text-dark">Refund Date:</span> <span class="col-6 text-dark"><b>{{cancelPolicyResponse.PolicyResponse.PolicyRefundDateTime}}</b></span></div>
        </div>
      </div>
      <button class="okButton" (click)="modaldismiss()">OK</button>
    </div>
  </ng-template>

  <ng-template #bad let-modal>
    <div class="modal-success">
      <img class="sucesspopup" src="assets/img/badicon.gif" />
      <h2 class="textpopupbad">Could Not Be Cancelled!</h2>
      <h5 class="textsubheadpopup text-dark">Error Code: <b>{{cancelPolicyResponse.PolicyResponse.ErrorCode}}</b></h5>
      <p class="text-dark">{{cancelPolicyResponse.PolicyResponse.ErrorMessage}}</p>
      <button class="okButton-f" (click)="modal.dismiss()">OK</button>
    </div>
  </ng-template>
</div>


<!-- <main class="main">
  <div *ngIf="cancelloader" style="width:100%;top:0;left:0;bottom:0;position:fixed;background:#000000e8;z-index:500;">
    <div class="loaderforPassenger">
      Loading
      <span class="loadspan"></span>
    </div>
  </div>
  <div id="nav-tab-card" class="container">
    <h3 class="text-dark text-center my-5">Cancel Policy</h3>
    <form role="form" (ngSubmit)="CancelBookedPlans(planCancelForm,sweet,bad)">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="fromow">ITINERARY NO.</label>
            <input type="text" name="itinerary" [(ngModel)]="cancelPolicy.itinerary" class="form-control">
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="goingtoow">POLICY NO. / CERTIFICATE NO.</label>
            <div class="input-group">
              <input type="text" name="policyno" class="form-control" [(ngModel)]="cancelPolicy.policyno">
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="goingtoow">PNR/IDENTIFICATION CODE</label>
            <div class="input-group">
              <input type="text" name="pnr" class="form-control" [(ngModel)]="cancelPolicy.pnr" required>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="fromow">PURCHASE DATE</label>
            <input type="text" name="purchasedate" placeholder="yyyy-MM-dd hh:mm:ss" [(ngModel)]="cancelPolicy.purchaseDate" class="form-control">
          </div>
        </div>
      </div>
      <hr />
      <div class="row mt-3">
        <div class="col-lg-3 col-md-3 col-sm-12">
          <button type="button" class="subscribe btn btn-block shadow-sm text-uppercase" (click)="ToDashboard()"><i class="fas fa-angle-double-left"></i> Dashboard  </button>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <button type="submit" [disabled]="!planCancelForm.valid" class="subscribe btn btn-block shadow-sm text-uppercase"> Proceed <i class="fas fa-angle-double-right"></i> </button>
        </div>
      </div>
    </form>
  </div>
  <ng-template #sweet let-modal>
    <div class="modal-success">
      <img class="sucesspopup" src="assets/img/newsuccess.gif" />
      <h2 class="textpopupsuccess">Cancellation Details</h2>
      <div class="container-fluid">
        <div class="my-2 pl-2">
          <div class="row col-12"><span class="col-6 text-dark">State:</span><span class="col-6 text-dark"> <b>{{cancelPolicyResponse.PolicyResponse.ItineraryState}}</b></span></div>
          <div class="row col-12"><span class="col-6 text-dark">Itinerary ID:</span><span class="col-6 text-dark"><b>{{cancelPolicyResponse.PolicyResponse.ItineraryID}}</b></span></div>
          <div class="row col-12"><span class="col-6 text-dark">Policy No:</span> <span class="col-6 text-dark"><b>{{cancelPolicyResponse.PolicyResponse.PolicyNo}}</b></span></div>
          <div class="row col-12"><span class="col-6 text-dark">PNR:</span> <span class="col-6 text-dark"><b>{{cancelPolicyResponse.PolicyResponse.PNR}}</b></span></div>
          <div class="row col-12"><span class="col-6 text-dark">Cancellation Date:</span> <span class="col-6 text-dark"><b>{{cancelPolicyResponse.PolicyResponse.PolicyCancelDateTime}}</b></span></div>
          <div class="row col-12"><span class="col-6 text-dark">Refund Date:</span> <span class="col-6 text-dark"><b>{{cancelPolicyResponse.PolicyResponse.PolicyRefundDateTime}}</b></span></div>
        </div>
      </div>
      <button class="okButton" (click)="modaldismiss()">OK</button>
    </div>
  </ng-template>
  <ng-template #bad let-modal>
    <div class="modal-success">
      <img class="sucesspopup" src="assets/img/badicon.gif" />
      <h2 class="textpopupbad">Could Not Be Cancelled!</h2>
      <h5 class="textsubheadpopup text-dark">Error Code: <b>{{cancelPolicyResponse.PolicyResponse.ErrorCode}}</b></h5>
      <p class="text-dark">{{cancelPolicyResponse.PolicyResponse.ErrorMessage}}</p>
      <button class="okButton-f" (click)="modal.dismiss()">OK</button>
    </div>
  </ng-template>
</main> -->
